import React, { Fragment } from 'react';
import { Grid, Autocomplete, TextField, Button } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

// คืนค่าเป็น Fragment ของ Grid item สองอัน (Autocomplete + ปุ่ม "ลูกค้าใหม่")
// ตั้งใจให้ parent วางไว้เป็น child ตรงของ <Grid container> เดียวกับฟิลด์อื่น ๆ
// เพื่อให้ spacing/wrap ของ MUI Grid ทำงานเหมือนอยู่ในไฟล์เดียวกัน
export function ClientAutocompleteField({
  options, value, onChange, inputValue, onInputChange, onAddNew,
}) {
  return (
    <Fragment>
      <Grid item xs={12} sm={9}>
        <Autocomplete
          size="small"
          options={options}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => (o._id || o.id) === (v._id || v.id)}
          value={value}
          onChange={(e, v) => onChange(v)}
          inputValue={inputValue}
          onInputChange={(e, v) => onInputChange(v)}
          renderInput={(params) => <TextField {...params} label="ลูกค้า (Client) *" />}
        />
      </Grid>
      <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
        <Button
          fullWidth variant="outlined" startIcon={<AddRoundedIcon />}
          onClick={onAddNew} sx={{ borderRadius: 2 }}
        >
          ลูกค้าใหม่
        </Button>
      </Grid>
    </Fragment>
  );
}

export default ClientAutocompleteField;
